function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var colors = {
  reaRed: "#e4002b",
  white: "#ffffff",
  snowgum50: "#F6F5F7",
  snowgum100: "#E5E3E8",
  snowgum200: "#BEBAC2",
  snowgum300: "#959199",
  snowgum400: "#726E75",
  snowgum500: "#565359",
  snowgum600: "#3D3B40",
  snowgum700: "#2E2C30",
  snowgum800: "#242326",
  snowgum900: "#1B1A1C",
  snowgum1000: "#0F0E0F",
  bondi50: "#DBF7FF",
  bondi200: "#7CD3F3",
  bondi400: "#0078BD",
  bondi300: "#36A5D9",
  bondi500: "#00639E",
  bondi600: "#005180",
  bondi700: "#10384F",
  eucalyptus50: "#DCFCE7",
  eucalyptus200: "#93D7AD",
  eucalyptus400: "#2D8659",
  eucalyptus500: "#137044",
  eucalyptus700: "#02452A",
  outback50: "#FFEEDB",
  outback200: "#FFA857",
  outback300: "#ED711F",
  outback400: "#D15408",
  outback500: "#A8420D",
  outback700: "#542615",
  sorrento50: "#FFF4D4",
  sorrento200: "#FCCA36",
  sorrento300: "#DCA218",
  sorrento500: "#995C00",
  sorrento700: "#5C2E00",
  whitsundays50: "#DDFCFA",
  whitsundays200: "#5AE2E0",
  whitsundays300: "#2BC5CA",
  whitsundays400: "#189AA3",
  whitsundays500: "#0C747D",
  whitsundays700: "#143C42",
  jacaranda50: "#F9EBFF",
  jacaranda200: "#D5B1EC",
  jacaranda400: "#8154AB",
  jacaranda500: "#66408D",
  jacaranda700: "#3A2459",
  coral50: "#FFE8EB",
  coral200: "#FFA3AB",
  coral300: "#F2636F",
  coral400: "#CE3548",
  coral500: "#A81E35",
  coral600: "#80192B",
  coral700: "#571D2A"
};

//prettier-ignore
var palette = {
  /** @section Text tokens */
  textPrimary: {
    light: colors.snowgum600,
    dark: colors.snowgum50
  },
  /** @section Text tokens */
  textSecondary: {
    light: colors.snowgum400,
    dark: colors.snowgum200
  },
  /** @section Text tokens */
  textInverted: {
    light: colors.white,
    dark: colors.snowgum600
  },
  /** @section Text tokens */
  textInvertedStatic: {
    light: colors.white,
    dark: colors.snowgum50
  },
  /** @section Text tokens */
  textInformation: {
    light: colors.bondi500,
    dark: colors.bondi200
  },
  /** @section Text tokens */
  textSuccess: {
    light: colors.eucalyptus500,
    dark: colors.eucalyptus200
  },
  /** @section Text tokens */
  textWarning: {
    light: colors.outback500,
    dark: colors.outback200
  },
  /** @section Text tokens */
  textSuccessInverted: {
    light: colors.eucalyptus200,
    dark: colors.eucalyptus500
  },
  /** @section Text tokens */
  textWarningInverted: {
    light: colors.outback200,
    dark: colors.outback500
  },
  /** @section Text tokens */
  textError: {
    light: colors.coral500,
    dark: colors.coral200
  },
  /** @section Text tokens */
  textBrand: {
    light: colors.reaRed,
    dark: colors.snowgum50
  },
  /** @section Background tokens */
  backgroundBrandStatic: {
    light: colors.reaRed,
    dark: colors.reaRed
  },
  /** @section Background tokens */
  backgroundPrimary: {
    light: colors.white,
    dark: colors.snowgum700
  },
  /** @section Background tokens */
  backgroundPrimaryBase: {
    light: colors.white,
    dark: colors.snowgum1000
  },
  /** @section Background tokens */
  backgroundPrimaryLow: {
    light: colors.white,
    dark: colors.snowgum900
  },
  /** @section Background tokens */
  backgroundPrimaryHigh: {
    light: colors.white,
    dark: colors.snowgum800
  },
  /** @section Background tokens */
  backgroundPrimaryInverted: {
    light: colors.snowgum600,
    dark: colors.snowgum100
  },
  /** @section Background tokens */
  backgroundPrimaryInvertedStatic: {
    light: colors.snowgum600,
    dark: colors.snowgum600
  },
  /** @section Background tokens */
  backgroundSecondaryBase: {
    light: colors.snowgum50,
    dark: colors.snowgum1000
  },
  /** @section Background tokens */
  backgroundSecondaryLow: {
    light: colors.snowgum50,
    dark: colors.snowgum900
  },
  /** @section Background tokens */
  backgroundSecondaryInvertedStatic: {
    light: colors.snowgum800,
    dark: colors.snowgum800
  },
  /** @section Background tokens */
  backgroundSecondary: {
    light: colors.snowgum100,
    dark: colors.snowgum600
  },
  /** @section Background tokens */
  backgroundInformation: {
    light: colors.bondi50,
    dark: colors.bondi700
  },
  /** @section Background tokens */
  backgroundSuccess: {
    light: colors.eucalyptus50,
    dark: colors.eucalyptus700
  },
  /** @section Background tokens */
  backgroundWarning: {
    light: colors.outback50,
    dark: colors.outback700
  },
  /** @section Background tokens */
  backgroundError: {
    light: colors.coral50,
    dark: colors.coral700
  },
  /** @section Background tokens */
  backgroundOverlayStatic: {
    light: "rgba(36, 34, 38, 0.8)",
    dark: "rgba(36, 34, 38, 0.8)"
  },
  //Snowgum 800
  /** @section Background tokens */
  backgroundSecondaryOverlay: {
    light: "rgba(36, 34, 38, 0.2)",
    dark: "rgba(36, 34, 38, 0.4)"
  },
  //Snowgum 800

  /** @section Border tokens */
  borderBrandStatic: {
    light: colors.reaRed,
    dark: colors.reaRed
  },
  /** @section Border tokens */
  borderPrimary: {
    light: colors.snowgum300,
    dark: colors.snowgum300
  },
  /** @section Border tokens */
  borderSecondary: {
    light: colors.snowgum100,
    dark: colors.snowgum500
  },
  /** @section Border tokens */
  borderInverted: {
    light: colors.white,
    dark: colors.snowgum600
  },
  /** @section Border tokens */
  borderInvertedStatic: {
    light: colors.snowgum300,
    dark: colors.snowgum300
  },
  /** @section Border tokens */
  borderErrored: {
    light: colors.outback500,
    dark: colors.outback300
  },
  /** @section Border tokens */
  borderSelected: {
    light: colors.snowgum600,
    dark: colors.snowgum50
  },
  /** @section Link tokens */
  linkPrimary: {
    light: colors.bondi500,
    dark: colors.bondi200
  },
  /** @section Link tokens */
  linkSecondary: {
    light: colors.snowgum400,
    dark: colors.snowgum200
  },
  /** @section Link tokens */
  linkHoveredPrimary: {
    light: colors.bondi600,
    dark: colors.bondi300
  },
  /** @section Link tokens */
  linkHoveredSecondary: {
    light: colors.snowgum500,
    dark: colors.snowgum300
  },
  /** @section Link tokens */
  linkPressedPrimary: {
    light: colors.bondi700,
    dark: colors.bondi400
  },
  /** @section Link tokens */
  linkPressedSecondary: {
    light: colors.snowgum600,
    dark: colors.snowgum400
  },
  /** @section Interaction state tokens */
  backgroundHoveredBrandStatic: {
    light: colors.coral500,
    dark: colors.coral500
  },
  /** @section Interaction state tokens */
  backgroundHoveredPrimary: {
    light: colors.snowgum50,
    dark: colors.snowgum600
  },
  /** @section Interaction state tokens */
  backgroundHoveredPrimaryInverted: {
    light: colors.snowgum800,
    dark: colors.snowgum200
  },
  /** @section Interaction state tokens */
  backgroundHoveredPrimaryInvertedStatic: {
    light: colors.snowgum800,
    dark: colors.snowgum500
  },
  /** @section Interaction state tokens */
  backgroundHoveredSecondary: {
    light: colors.snowgum200,
    dark: colors.snowgum500
  },
  /** @section Interaction state tokens */
  backgroundPressedBrandStatic: {
    light: colors.coral600,
    dark: colors.coral600
  },
  /** @section Interaction state tokens */
  backgroundPressedPrimary: {
    light: colors.snowgum100,
    dark: colors.snowgum500
  },
  /** @section Interaction state tokens */
  backgroundPressedPrimaryInverted: {
    light: colors.snowgum800,
    dark: colors.snowgum300
  },
  /** @section Interaction state tokens */
  backgroundPressedPrimaryInvertedStatic: {
    light: colors.snowgum900,
    dark: colors.snowgum500
  },
  /** @section Interaction state tokens */
  backgroundPressedSecondary: {
    light: colors.snowgum300,
    dark: colors.snowgum400
  },
  /** @section Interaction state tokens */
  backgroundFocusedPrimary: {
    light: colors.snowgum50,
    dark: colors.snowgum500
  },
  /** @section Interaction state tokens */
  backgroundSelected: {
    light: colors.snowgum600,
    dark: colors.snowgum50
  },
  /** @section Interaction state tokens */
  backgroundSelectedBrand: {
    light: colors.coral50,
    dark: colors.coral700
  },
  /** @section Interaction state tokens */
  borderHovered: {
    light: colors.snowgum600,
    dark: colors.snowgum200
  },
  /** @section Interaction state tokens */
  borderHoveredInverted: {
    light: colors.snowgum50,
    dark: colors.snowgum500
  },
  /** @section Interaction state tokens */
  borderPressed: {
    light: colors.snowgum600,
    dark: colors.snowgum50
  },
  /** @section Interaction state tokens */
  borderPressedInverted: {
    light: colors.snowgum600,
    dark: colors.snowgum500
  },
  /** @section Interaction state tokens */
  borderFocused: {
    light: colors.snowgum600,
    dark: colors.snowgum50
  },
  /** @section Interaction state tokens */
  borderFocusedInvertedStatic: {
    light: colors.snowgum50,
    dark: colors.snowgum50
  },
  /** @section Disabled tokens */
  textDisabled: {
    light: colors.snowgum200,
    dark: colors.snowgum500
  },
  /** @section Disabled tokens */
  backgroundDisabled: {
    light: colors.snowgum50,
    dark: colors.snowgum600
  },
  //check
  /** @section Disabled tokens */
  borderDisabled: {
    light: colors.snowgum100,
    dark: colors.snowgum500
  },
  /** @section Accent tokens */
  graphicOrange: {
    light: colors.outback300,
    dark: colors.outback400
  },
  /** @section Accent tokens */
  graphicYellow: {
    light: colors.sorrento200,
    dark: colors.sorrento300
  },
  /** @section Accent tokens */
  graphicTeal: {
    light: colors.whitsundays300,
    dark: colors.whitsundays400
  },
  /** @section Accent tokens */
  graphicBlue: {
    light: colors.bondi400,
    dark: colors.bondi400
  },
  /** @section Accent tokens */
  graphicPurple: {
    light: colors.jacaranda400,
    dark: colors.jacaranda400
  },
  /** @section Accent tokens */
  graphicPink: {
    light: colors.coral300,
    dark: colors.coral400
  },
  /** @section Accent tokens */
  graphicGreen: {
    light: colors.eucalyptus400,
    dark: colors.eucalyptus400
  },
  /** @section Accent background tokens */
  backgroundBlue: {
    light: colors.bondi50,
    dark: colors.bondi700
  },
  /** @section Accent background tokens */
  backgroundPink: {
    light: colors.coral50,
    dark: colors.coral700
  },
  /** @section Accent background tokens */
  backgroundGreen: {
    light: colors.eucalyptus50,
    dark: colors.eucalyptus700
  },
  /** @section Accent background tokens */
  backgroundPurple: {
    light: colors.jacaranda50,
    dark: colors.jacaranda700
  },
  /** @section Accent background tokens */
  backgroundOrange: {
    light: colors.outback50,
    dark: colors.outback700
  },
  /** @section Accent background tokens */
  backgroundYellow: {
    light: colors.sorrento50,
    dark: colors.sorrento700
  },
  /** @section Accent background tokens */
  backgroundTeal: {
    light: colors.whitsundays50,
    dark: colors.whitsundays700
  },
  /** @section Accent text tokens */
  textBlue: {
    light: colors.bondi500,
    dark: colors.bondi200
  },
  /** @section Accent text tokens */
  textPink: {
    light: colors.coral500,
    dark: colors.coral200
  },
  /** @section Accent text tokens */
  textGreen: {
    light: colors.eucalyptus500,
    dark: colors.eucalyptus200
  },
  /** @section Accent text tokens */
  textPurple: {
    light: colors.jacaranda500,
    dark: colors.jacaranda200
  },
  /** @section Accent text tokens */
  textOrange: {
    light: colors.outback500,
    dark: colors.outback200
  },
  /** @section Accent text tokens */
  textYellow: {
    light: colors.sorrento500,
    dark: colors.sorrento200
  },
  /** @section Accent text tokens */
  textTeal: {
    light: colors.whitsundays500,
    dark: colors.whitsundays200
  }
};
var spacing = {
  twoExtraSmall: "0.25rem",
  extraSmall: "0.5rem",
  small: "0.75rem",
  medium: "1rem",
  large: "1.5rem",
  extraLarge: "2rem",
  twoExtraLarge: "2.5rem",
  threeExtraLarge: "3rem"
};
var fontFaces = {
  pangeaText: {
    fontFamily: '"Pangea", "Helvetica Neue", Helvetica, Arial, sans-serif',
    fontVariationSettings: '"XTDR" 50, "APRT" 100, "SPAC" 40'
  },
  pangeaHeading: {
    fontFamily: '"Pangea", "Helvetica Neue", Helvetica, Arial, sans-serif',
    fontVariationSettings: '"XTDR" 0, "APRT" 0, "SPAC" 0'
  }
};
var fonts = {
  lightText: _extends({}, fontFaces.pangeaText, {
    fontWeight: 300
  }),
  regularText: _extends({}, fontFaces.pangeaText, {
    fontWeight: 400
  }),
  mediumText: _extends({}, fontFaces.pangeaText, {
    fontWeight: 500
  }),
  semiBoldText: _extends({}, fontFaces.pangeaText, {
    fontWeight: 600
  }),
  boldText: _extends({}, fontFaces.pangeaText, {
    fontWeight: 700
  }),
  light: _extends({}, fontFaces.pangeaHeading, {
    fontWeight: 300
  }),
  regular: _extends({}, fontFaces.pangeaHeading, {
    fontWeight: 400
  }),
  medium: _extends({}, fontFaces.pangeaHeading, {
    fontWeight: 500
  }),
  semiBold: _extends({}, fontFaces.pangeaHeading, {
    fontWeight: 600
  }),
  bold: _extends({}, fontFaces.pangeaHeading, {
    fontWeight: 700
  })
};
var typography = {
  display: _extends({
    fontSize: "3rem",
    lineHeight: "4rem"
  }, fonts.regular),
  largeTitle: _extends({
    fontSize: "2.125rem",
    lineHeight: "2.75rem"
  }, fonts.semiBold),
  title01: _extends({
    fontSize: "1.5rem",
    lineHeight: "2.25rem"
  }, fonts.semiBold),
  title02: _extends({
    fontSize: "1.25rem",
    lineHeight: "1.75rem"
  }, fonts.semiBold),
  title03: _extends({
    fontSize: "1.125rem",
    lineHeight: "1.5rem"
  }, fonts.semiBold),
  subtitle01: _extends({
    fontSize: "1rem",
    lineHeight: "1.5rem"
  }, fonts.medium),
  subtitle02: _extends({
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    letterSpacing: "0.0125rem"
  }, fonts.medium),
  subtitle03: _extends({
    fontSize: "0.75rem",
    lineHeight: "1rem",
    letterSpacing: "0.0125rem"
  }, fonts.medium),
  body01: _extends({
    fontSize: "1rem",
    lineHeight: "1.5rem"
  }, fonts.regularText),
  body02: _extends({
    fontSize: "0.875rem",
    lineHeight: "1.25rem"
  }, fonts.regularText),
  caption: _extends({
    fontSize: "0.75rem",
    lineHeight: "1rem"
  }, fonts.regularText),
  overline: _extends({
    fontSize: "0.75rem",
    lineHeight: "1rem",
    textTransform: "uppercase",
    letterSpacing: "0.025rem"
  }, fonts.mediumText),
  strong: {
    fontWeight: 600
  }
};
var border = {
  width: {
    thin: "0.0625rem",
    thick: "0.125rem"
  },
  radius: {
    small: "0.25rem",
    medium: "0.5rem",
    large: "0.75rem"
  }
};
var layoutMediaQueries = {
  medium: "@media only screen and (min-width: 31.3125rem)",
  tablet: "@media only screen and (min-width: 48rem)",
  large: "@media only screen and (min-width: 62.5rem)"
};
var shadow = "0 0.0625rem 0.25rem 0 rgba(0, 0, 0, 0.16)";
export { palette };
var foundations = {
  palette,
  spacing,
  typography,
  border,
  layoutMediaQueries,
  shadow
};
export default foundations;